import React from 'react'
import Modal from 'react-modal'
import { docModalStylesNew } from '../utils/styles'
import closeIconModal from '../../assets/img/cross-modal-icon.png'
import arrowDownIcon from '../../assets/img/fecha-filtro-avisos-mantenimiento.svg'

const OrdenarAvisosMantenimientoModal = ({
  displayModal,
  setDisplayModal,
  closeModal,
  distanceToTop,
  setOptionsModalTitle,
  setNroAvisoFilterValue,
  setFechaAvisoFilterValue,
  setPrioridadFilterValue,
  setProductoFilterValue,
  nroAvisoFilterValue,
  fechaAvisoFilterValue,
  prioridadFilterValue,
  productoFilterValue,
  openOpcionesOrdenamientoModal,
  onOrdenar,
  onRestablecerOrden,
  isCobrosPorFormular = false,
  fechaOrdenFilterValue,
  setFechaOrdenFilterValue,
  nroOrdenFilterValue,
  setNroOrdenFilterValue,
  montoPlanFilterValue,
  setMontoPlanFilterValue,
  estadoFilterValue,
  setEstadoFilterValue,
}) => {

  const handleFilterClick = (filter) => {
    setOptionsModalTitle(filter)
    openOpcionesOrdenamientoModal()
    setDisplayModal(false)
  }

  const restablecerButtonClick = () => {
    // Mantener comportamiento actual (reset selects)
    if (isCobrosPorFormular) {
      setNroOrdenFilterValue({label: "Seleccionar", value: "seleccionar"})
      setFechaOrdenFilterValue({label: "Seleccionar", value: "seleccionar"})
      setEstadoFilterValue({label: "Seleccionar", value: "seleccionar"})
      setMontoPlanFilterValue({label: "Seleccionar", value: "seleccionar"})
    } else {
      setNroAvisoFilterValue({label: "Seleccionar", value: "seleccionar"})
      setFechaAvisoFilterValue({label: "Seleccionar", value: "seleccionar"})
      setPrioridadFilterValue({label: "Seleccionar", value: "seleccionar"})
      setProductoFilterValue({label: "Seleccionar", value: "seleccionar"})
    }
    // Nuevo: además restaurar data al orden inicial
    if (typeof onRestablecerOrden === 'function') {
      onRestablecerOrden()
    }
  }

  const ordenarButtonClick = () => {
    if (typeof onOrdenar === 'function') {
      onOrdenar()
    } else {
      closeModal()
    }
  }

  return (
    <Modal
      isOpen={displayModal}
      onRequestClose={closeModal}
      style={docModalStylesNew(distanceToTop - 20)}
    >
      <div className="orden-avisos-mantenimiento-modal-container">
        <div className="title-label-container">
          <div className="title">
            Ordenar
          </div>
          <img onClick={closeModal} src={closeIconModal} alt="close modal" />
        </div>
        <div className="ordenar-avisos-mantenimiento-modal-separator"></div>
        <div className="filtro-blocks-container">
          <div className="filtro-block">
            <div className="filtro-block-title">
              { isCobrosPorFormular ? 'Nº DE ORDEN' : 'Nº DE AVISO'}
            </div>
            <div className="filtro-block-input" onClick={() => handleFilterClick(isCobrosPorFormular ? 'nro_orden' : 'nro_aviso')}>
              <div className="input-value">
                { isCobrosPorFormular ? nroOrdenFilterValue?.label : nroAvisoFilterValue?.label}
              </div>
              <img src={arrowDownIcon} alt="arrow down" />
            </div>
          </div>
          <div className="filtro-block">
            <div className="filtro-block-title">
              { isCobrosPorFormular ? 'FECHA DE ORDEN' : 'FECHA DE AVISO'}
            </div>
            <div className="filtro-block-input" onClick={() => handleFilterClick(isCobrosPorFormular ? 'fecha_orden' : 'fecha_aviso')}>
              <div className="input-value">
                { isCobrosPorFormular ? fechaOrdenFilterValue?.label : fechaAvisoFilterValue?.label}
              </div>
              <img src={arrowDownIcon} alt="arrow down" />
            </div>
          </div>
          <div className="filtro-block">
            <div className="filtro-block-title">
              { isCobrosPorFormular ? 'ESTADO' : 'PRIORIDAD'}
            </div>
            <div className="filtro-block-input" onClick={() => handleFilterClick(isCobrosPorFormular ? 'estado' : 'prioridad')}>
              <div className="input-value">
                {isCobrosPorFormular ? estadoFilterValue?.label : prioridadFilterValue?.label}
              </div>
              <img src={arrowDownIcon} alt="arrow down" />
            </div>
          </div>
          <div className="filtro-block">
            <div className="filtro-block-title">
              { isCobrosPorFormular ? 'MONTO PLAN' : 'PRODUCTO'}
            </div>
            <div className="filtro-block-input" onClick={() => handleFilterClick(isCobrosPorFormular ? 'monto_plan' : 'producto')}>
              <div className="input-value">
                {isCobrosPorFormular ? montoPlanFilterValue?.label : productoFilterValue?.label}
              </div>
              <img src={arrowDownIcon} alt="arrow down" />
            </div>
          </div>
        </div>
        <div className="ordenar-avisos-mantenimiento-modal-separator"></div>
        <div className="buttons-container">
          <button className="main-button hallow" onClick={restablecerButtonClick}>
            Restablecer Orden
          </button>
          <button className="main-button" onClick={ordenarButtonClick}>
            Ordenar
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default OrdenarAvisosMantenimientoModal
